import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, Chip
} from '@material-ui/core';
import { differenceWith } from 'lodash-es';

import { 
  CLOSE_DLG_SUBMENU, UPDATE_SUBMENU, 
  selectIsOpenSubMenuDialog, selectFocusedMenu, selectMenu
} from "./reducer";
import { reqSubMenus } from './api'

const SubMenuDialog = (props) => {

  const dispatch = useDispatch();

  const open = useSelector(selectIsOpenSubMenuDialog);

  const focusedMenu = useSelector(selectFocusedMenu);

  const menu = useSelector(state => selectMenu(state, 
      focusedMenu ? focusedMenu.date : null, 
      focusedMenu ? focusedMenu.serviceTime : null, 
      focusedMenu ? focusedMenu.menuId : null));

  // subMenus UI states 
  // [{ id, name, selected }]
  const [ subMenus, setSubMenus ] = useState([]);

  const [ loading, setLoading ] = useState(false);

  const handleEnter = async () => {
    
    // request subMenus
    try {
      setLoading(true);

      const { data } = await reqSubMenus(menu.menuId);
      const newSubMenus = data.map((subMenu, i) => {
        const selected = menu.subMenu.some(item => item.name === subMenu.name);
        return {
          id: subMenu.id,
          name: subMenu.name,
          selected
        };
      });
      // sub menu 항목이 변경될 경우 처리 
      const diff = differenceWith(menu.subMenu, newSubMenus, (a, b) => (a.name === b.name))
        .map(item => {
          item.selected = true;
          return item;
        });
      setSubMenus(newSubMenus.concat(diff));

      setLoading(false);
    } catch (err) {
      setSubMenus([]);
      setLoading(false);
      console.error(err);
    }
  }

  const handleClose = () => {
    dispatch({ type: CLOSE_DLG_SUBMENU });
  }

  const handleApply = evt => {
    dispatch({ type: CLOSE_DLG_SUBMENU });
    
    dispatch({
      type: UPDATE_SUBMENU,
      payload: {
        date: focusedMenu.date, 
        serviceTime: focusedMenu.serviceTime,
        menuId: focusedMenu.menuId,
        subMenus: subMenus.filter(sm => sm.selected).map(sm => ({ id: sm.id, name: sm.name }))
      }
    });
  }

  const handleSelect = id => {
    setSubMenus(subMenus => subMenus.map(
        subMenu => subMenu.id === id ? 
          { ...subMenu, selected: true } : subMenu));
  };

  const handleDelete = id => {
    setSubMenus(subMenus => subMenus.map(
        subMenu => subMenu.id === id ? 
          { ...subMenu, selected: false } : subMenu));
  };

  return (
    <Dialog
      open={open}
      onEnter={handleEnter}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle
        id="form-dialog-title"
      >
        서브 메뉴 선택 
      </DialogTitle>
      <DialogContent>
        {subMenus.map((subMenu, i) => 
          subMenu.selected ? (
            <Chip 
              key={i}
              color="primary"
              variant="outlined"
              size="small"
              label={subMenu.name}
              onDelete={() => { handleDelete(subMenu.id) }}
            />
          ):(
            <Chip 
              key={i}
              variant="outlined"
              size="small"
              label={subMenu.name}
              onClick={() => { handleSelect(subMenu.id) }}
            />
          )
        )}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
        >
          Cancel
        </Button>
        <Button
          onClick={handleApply}
        >
          Apply
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default SubMenuDialog;